"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginalImpersonatorOrganization = exports.setOrganization = exports.getOrganization = exports.setUser = exports.getUser = void 0;
var token_1 = require("./token");
var user;
var organization;
function getUser() {
    return user;
}
exports.getUser = getUser;
function setUser(userToSet) {
    user = userToSet;
}
exports.setUser = setUser;
function getOrganization() {
    return organization;
}
exports.getOrganization = getOrganization;
function setOrganization(organizationToSet) {
    organization = organizationToSet;
}
exports.setOrganization = setOrganization;
// if impersonating return original organization, otherwise return acting organization
function getOriginalImpersonatorOrganization() {
    var impersonation = (0, token_1.getImpersonationDetails)();
    return impersonation ? impersonation.originalTenant : organization;
}
exports.getOriginalImpersonatorOrganization = getOriginalImpersonatorOrganization;
